const flagImages = import.meta.glob('/src/assets/img/assets/flags/*.svg', { eager: true });

export const getImgPath = (value) => {
    const imagePath = `/src/assets/img/assets/flags/${value}.svg`;
    return flagImages[imagePath] ? flagImages[imagePath].default : null;
};
